import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import "./Footer.css";

function Footer() {
  return (
    <>
      {/*Start Site Footer*/}
      <footer className="site-footer site-footer--one">
        <div
          className="site-footer__bg"
          style={{
            backgroundImage:
              "url(assets/images/backgrounds/site-footer-bg.jpg)",
          }}
        ></div>
        <div className="shape1">
          <img src="assets/images/shapes/site-footer-v1-shape1.png" alt="" />
        </div>
        <div className="shape2 float-bob-x">
          <img src="assets/images/shapes/site-footer-v1-shape2.png" alt="" />
        </div>
        <div className="shape3 float-bob-y">
          <img src="assets/images/shapes/site-footer-v1-shape3.png" alt="" />
        </div>
        <div className="container">
          <div className="site-footer__top">
            <ul className="row site-footer__top-contact-info">
              <li className="col-xl-4 col-lg-4 site-footer__top-contact-info-single">
                <div className="site-footer__top-contact-info-single-inner">
                  <div className="icon-box">
                    <span className="icon-telephone" />
                  </div>
                  <div className="content-box">
                    <p>Call Emergency</p>
                    <h3>
                      <a href="tel:+916742549187">+91-674-2549187</a>
                    </h3>
                  </div>
                </div>
              </li>
              <li className="col-xl-4 col-lg-4 site-footer__top-contact-info-single">
                <div className="site-footer__top-contact-info-single-inner">
                  <div className="icon-box">
                    <span className="icon-mail" />
                  </div>
                  <div className="content-box">
                    <p>Email Us</p>
                    <h3>
                      <a href="mailto:info@vikash.org">info@vikash.org</a>
                    </h3>
                  </div>
                </div>
              </li>
              <li className="col-xl-4 col-lg-4 site-footer__top-contact-info-single">
                <div className="site-footer__top-contact-info-single-inner">
                  <div className="icon-box">
                    <span className="icon-location" />
                  </div>
                  <div className="content-box">
                    <p>Address</p>
                    <h3>Rasulgarh, Bhubaneswar</h3>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div className="site-footer__middle">
            <div className="row">
              {/* Logo and Social */}
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="footer-widget__column footer-widget__about">
                  <div className="footer-widget__logo">
                    <Link to="/">
                      <img src="assets/images/resources/lg.png" alt="" />
                    </Link>
                  </div>
                  <p className="footer-widget__about-text">
                    Vikash has come a long way as a Non-Governmental
                    Organization in Odisha, working towards Sustainable
                    Development and People’s Rights since 1986.
                  </p>
                  <div className="footer-widget__about-social-links">
                    <a
                      href="https://www.facebook.com/vikashNGOindia/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="icon-facebook-app-symbol" />
                    </a>
                    <a
                      href="https://x.com/VikashIndia1"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="icon-twitter" />
                    </a>
                    <a
                      href="https://www.youtube.com/@Vikashngobbsr"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="icon-youtube" />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/vikash-vikash-802a3826/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="icon-linkedin-big-logo" />
                    </a>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="footer-widget__column footer-widget__useful-link ml85">
                  <div className="footer-widget__title-box">
                    <h3 className="footer-widget__title">Quick Links</h3>
                  </div>
                  <div className="footer-widget__link-box">
                    <ul className="footer-widget__link">
                      <li>
                        <Link to="/about-vikash">
                          <span className="icon-next" /> About Us
                        </Link>
                      </li>
                      <li>
                       

                         <HashLink smooth to="/#os">  <span className="icon-next" /> Our Services</HashLink>
                      </li>
                      <li>
                        <Link to="/blog">
                          <span className="icon-next" /> Our Blogs
                        </Link>


                        
                      </li>
                      <li>
                        {/* <Link to="/faq">
                          <span className="icon-next" /> FAQ’s
                        </Link> */}

                        <HashLink smooth to="/#fq">  <span className="icon-next" /> FAQ’s</HashLink>
                      </li>
                      <li>
                        <Link to="/contact-us">
                          <span className="icon-next" /> Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Services */}
             {/* We Are At */}
{/* We are at */}
{/* We are at */}
<div
  className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp text-center"
  data-wow-delay="0.3s"
>
  <div
    className="footer-widget__column footer-widget__contact-info"
    style={{ textAlign: "center" }}
  >
    <div className="footer-widget__title-box">
      <h3
        className="footer-widget__title"
        style={{ textAlign: "center", marginBottom: "15px" }}
      >
        We are at
      </h3>
    </div>

    <ul
      className="footer-widget__contact-list"
      style={{
        listStyle: "none",
        padding: 0,
        margin: 0,
        textAlign: "center",
        display: "inline-block",
      }}
    >
      <li style={{ marginBottom: "12px" }}>
        <span
          className="icon-location"
          style={{ marginRight: "8px", color: "#00b894" }}
        />
        <span style={{ color: "#fff" }}>
          D – 2/7, Industrial Estate,<br />
          Rasulgarh, Bhubaneswar, Odisha, India – 751010
        </span>
      </li>
      <li style={{ marginBottom: "12px" }}>
        <span
          className="icon-telephone"
          style={{ marginRight: "8px", color: "#00b894" }}
        />
        <a
          href="tel:+916742548306"
          style={{ color: "#fff", textDecoration: "none" }}
        >
          +91-674-2548306
        </a>
      </li>
      <li>
        <span
          className="icon-mail"
          style={{ marginRight: "8px", color: "#00b894" }}
        />
        <a
          href="mailto:info@vikash.org"
          style={{ color: "#fff", textDecoration: "none" }}
        >
          info@vikash.org
        </a>
      </li>
    </ul>
  </div>
</div>




              {/* Map Section (Replaces Newsletter) */}
              <div
                className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp"
                data-wow-delay="0.4s"
              >
                <div className="footer-widget__column footer-widget__map">
                  <div className="footer-widget__title-box">
                    <h3 className="footer-widget__title">Find Us</h3>
                  </div>
                  <div className="footer-widget__map-inner">
                    <iframe
                      title="vikash-map"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1818.7743106740334!2d85.85343859388173!3d20.294655998350525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190b0dc87c8485%3A0x9baf51bb9cd08a17!2sYUBI%20(Eat%20Healthy%20%3A%20Live%20Young)!5e0!3m2!1sen!2sin!4v1758619294270!5m2!1sen!2sin"
                      width="100%"
                      height="200"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="site-footer__bottom">
          <div className="container">
            <div className="site-footer__bottom-inner">
              <p className=" text-center site-footer__bottom-text">
                © All Copyright 2025 by <Link to="https://uptulasoft.com/">Uptulasoft</Link>
              </p>
              <ul className="site-footer__bottom-menu">
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-conditions">Terms & Conditions</Link>
                </li>
              </ul>
              <p className="site-footer__bottom-credit">
                Designed with <span className="heart">♥</span> for a better tomorrow
              </p>
              {/* <ul className="site-footer__bottom-menu">
                <li>
                  <Link to="/about">Terms and Condition</Link>
                </li>
                <li>
                  <Link to="/about">Privacy and Policy</Link>
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </footer>
      {/*End Site Footer*/}
    </>
  );
}

export default Footer;
